var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramShares64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Shares64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(3.000000, 13.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Line",
    strokeLinecap: "square",
    points: "5 33 21 14 37 26 53 4.99487305"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,5.03999996 C48,2.28270553 50.2427056,0.0399999619 53,0.0399999619 C55.7559682,0.0399999619 58,2.28270553 58,5.03999996 C58,7.79596813 55.7559682,10.04 53,10.04 C50.2427056,10.04 48,7.79596813 48,5.03999996 Z",
    id: "Point-4",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,26 C32,23.2427056 34.2427056,21 37,21 C39.7572944,21 42,23.2427056 42,26 C42,28.7559682 39.7572944,31 37,31 C34.2427056,31 32,28.7559682 32,26 Z",
    id: "Point-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,14 C16,11.2427056 18.2427056,9 21,9 C23.7572944,9 26,11.2427056 26,14 C26,16.7572944 23.7572944,19 21,19 C18.2427056,19 16,16.7572944 16,14 Z",
    id: "Point-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,38 C2.24270557,38 0,35.7572944 0,33 C0,30.2427056 2.24270557,28 5,28 C7.75729443,28 10,30.2427056 10,33 C10,35.7572944 7.75729443,38 5,38",
    id: "Point-1",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramShares64);
export default __webpack_public_path__ + "static/media/pictogramShares64.0436410e93b178412b159c8854e5494d.svg";
export { ForwardRef as ReactComponent };